import React from 'react';
import { Header } from './components/Header';
import { About } from './components/About';
import { Specializations } from './components/Specializations';
import { Qualifications } from './components/Qualifications';
import { Experience } from './components/Experience';
import { Availability } from './components/Availability';
import { Contact } from './components/Contact';
import { ContactSection } from './components/ContactSection';
import { ScrollNav } from './components/ScrollNav';
import { MobileScrollIndicator } from './components/MobileScrollIndicator';
import { Footer } from './components/Footer';
import { MobileNav } from './components/MobileNav';
// Add animation styles
import './animations.css';
export function App() {
  return <div className="bg-gray-900 text-gray-100 min-h-screen w-full pb-16 md:pb-0" data-id="element-0">
      {/* Scroll Navigation */}
      <ScrollNav data-id="element-1" />
      {/* Mobile Scroll Indicator */}
      <MobileScrollIndicator data-id="element-2" />
      <section id="home" data-id="element-3">
        <Header data-id="element-4" />
      </section>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5">
        <section id="about" data-id="element-6">
          <About data-id="element-7" />
        </section>
        <section id="services" data-id="element-8">
          <Specializations data-id="element-9" />
        </section>
        <section id="qualifications" data-id="element-10">
          <Qualifications data-id="element-11" />
        </section>
        <section id="experience" data-id="element-12">
          <Experience data-id="element-13" />
        </section>
        <section id="availability" data-id="element-14">
          <Availability data-id="element-15" />
        </section>
        {/* Old contact form - hidden but preserved */}
        <section id="contact" className="hidden" data-id="element-16">
          <Contact data-id="element-17" />
        </section>
      </main>
      {/* New Contact Section */}
      <section id="contact-new" data-id="element-18">
        <ContactSection data-id="element-19" />
      </section>
      <Footer data-id="element-20" />
      <MobileNav data-id="element-21" />
    </div>;
}